import { render, staticRenderFns } from "./BuyBusinessAdd.vue?vue&type=template&id=5df3a514&scoped=true&"
import script from "./BuyBusinessAdd.vue?vue&type=script&lang=js&"
export * from "./BuyBusinessAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df3a514",
  null
  
)

export default component.exports